import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'time-picker',
    templateUrl: './time-picker.component.html',
    styleUrls: ['./time-picker.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class TimePickerComponent implements OnInit {

    // Get selected date object chnage events
    @Output() dateChange = new EventEmitter<Date>();

    @Input('date') set date(date: Date) { this.initTime(date) };
    @Input('showTime') showTime: boolean = true;
    @Input('showIcons') showIcons: boolean = true;

    public time: Date = null;
    public datePick: Date = null;

    constructor() {
    }

    private initTime(date: Date) {
        if(!date) return;
        this.time = date;
        this.datePick = new Date(new Date(this.time.getFullYear(), this.time.getMonth(), this.time.getDate()).getTime());
        this.emitDateTime(this.datePick);
    }

    private emitDateTime(date: Date) {
        // Synch time object
        this.time.setDate(date.getDate());
        this.time.setMonth(date.getMonth());
        this.time.setFullYear(date.getFullYear());
        // Emit change event
        this.dateChange.emit(this.time);
    }

    /**
     * On date label selection of date popup
     */
    public dateSelected(date: Date) {
        if(!this.time) this.time = date;
        this.datePick = date;
        // Make sure we don't manipulate input date object reference unintended
        this.time = new Date(this.time);
        // Synch time object
        this.time.setDate(date.getDate());
        this.time.setMonth(date.getMonth());
        this.time.setFullYear(date.getFullYear());
        this.emitDateTime(this.time);
    }

    /**
     * On time selected through label/clock 
     */
    public timeSelected(ev: any) {
        let [hour, min] = ev.target.value.split(":");
        this.time = new Date(this.datePick.getTime());
        this.time.setHours(parseInt(hour));
        this.time.setMinutes(parseInt(min));
        // Never sync date object
        //this.start = this.startTime.getTime();
        this.dateChange.emit(this.time);
    }

    ngOnInit(): void {
    }
}
